const SERVER_URL =
  "https://nick-itkin-backend-nodejs-895924407291.us-central1.run.app/";

const BUCKET_URL = "https://storage.googleapis.com/cdn-roundtechsquare/";

module.exports = {
  SERVER_URL,
  BUCKET_URL,
};
